import { http } from '@/utils/plugins/http'

export const setProductsToDisplayLimitForUser = (limit) => http.post(`/users/product_number_to_display?product_number_to_display=${limit}`);
export const updateUser = (payload) => http.put('users', payload)
export const uploadUserImage = (payload) => http.post('user_images', payload)
export const getUserEmails = () => http.get('emails')
export const deleteUserEmail = (id) => http.delete(`emails/${id}`)
export const addNewEmail = (obj) => http.post(`emails`,obj)
export const setPrimaryEmail = (id) => http.put(`emails/${id}/set_primary`)